import containerFuild from '../html-snippets/container-fuild.js';
import css from '../tpl-css/style-section-cefloreco-lets-talk.js';

const html = `
<div
  data-use-custom-width="true"
  data-custom-width="1204"
  class="container"
  data-attribute="container-content"
  style="--custom-width: 1204px;"
>
  <div class="layout-section">
    <div class="title-section" data-attribute="title-section">
      <p>Our principles</p>
      <h2>Simple on purpose.</h2>
    </div>

    <div
      class="list-fetures"
      data-attribute="list-fetures"
      data-color-border-item="#bebebe"
      data-color-highlight-item="#ff7657"
      style="--color-border-item: #bebebe; --color-highlight-item: #ff7657;"
    >
      <div class="item-feture" data-attribute="item-freture">
        <div class="stt-item" data-attribute="stt-item">01</div>
        <div class="content-item" data-attribute="content-item">
          <h4>Product Strategy</h4>
          <p>Turning ideas and user insights into products built for real market opportunities.</p>
        </div>
      </div>

      <div class="item-feture" data-attribute="item-freture">
        <div class="stt-item" data-attribute="stt-item">02</div>
        <div class="content-item" data-attribute="content-item">
          <h4>Product Strategy</h4>
          <p>Turning ideas and user insights into products built for real market opportunities.</p>
        </div>
      </div>

      <div class="item-feture" data-attribute="item-freture">
        <div class="stt-item" data-attribute="stt-item">03</div>
        <div class="content-item" data-attribute="content-item">
          <h4>Product Strategy</h4>
          <p>Turning ideas and user insights into products built for real market opportunities.</p>
        </div>
      </div>
    </div>

    <a href="#" class="banner-image" data-attribute="banner-image" data-use-banner-mobile="true">
      <img
        class="banner-desktop"
        data-attribute="banner-desktop"
        src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae058d1645741cd91720996.webp?w=1000&q=100"
        alt=""
      />
      <img
        class="banner-mobile"
        data-attribute="banner-mobile"
        src="https://cdn.skyfastimg.com/images/2026/10/27/image-6ae05aee19fedd67bfb162cf.webp?w=1000&q=100"
        alt=""
      />
    </a>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#000',
  textColor: '#FFF',
  topPadding: true,
  bottomPadding: true,
});
